module.exports = __webpack_public_path__ + "static/media/Eclipse.0b40535c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Eclipse.gif
// module id = 378
// module chunks = 0